/**
 * Checks whether a panel-editor center can safely be used by the map and
 * distance calculations. A latitude/longitude of zero is valid; only missing
 * and non-finite values are rejected.
 */
export function isValidCoordinates(cords: cordPoint | null | undefined): cords is cordPoint {
  return Boolean(
    cords
    && typeof cords.lat === 'number'
    && Number.isFinite(cords.lat)
    && typeof cords.lng === 'number'
    && Number.isFinite(cords.lng),
  );
}
